import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ResourceAccessPage } from "@/features/console/pages/ResourceAccessPage";

export const Route = createFileRoute("/_authed/_modal/console/connection-access/$connectionId")({
  component: ConnectionAccessRoute,
});

function ConnectionAccessRoute(): React.ReactElement {
  const { connectionId } = Route.useParams();
  return <ResourceAccessPage connectionId={connectionId} />;
}
